import { WT_SURVEY_CRAWLER_UA_TOKENS } from './constants';

// Cypress running in Electron does not set navigator.webdriver, so the injected
// Cypress global is checked too.
export const isAutomation = (): boolean => {
  if (typeof navigator !== 'undefined' && (navigator as Navigator & { webdriver?: boolean }).webdriver) {
    return true;
  }
  return typeof window !== 'undefined' && !!(window as Window & { Cypress?: unknown }).Cypress;
};

export const isCrawlerUserAgent = (userAgent: string | undefined): boolean => {
  if (!userAgent) {
    return false;
  }
  const normalized = userAgent.toLowerCase();
  return WT_SURVEY_CRAWLER_UA_TOKENS.some((token) => normalized.includes(token));
};
